module.exports = __webpack_public_path__ + "static/media/18.70a64bcb.gif";